import * as TP from '../subscriptionTypes';

import { gql } from '@apollo/client';
export type OptimizationExecutionStatusEventPayloadFragment = (
  { readonly __typename?: 'OptimizationExecutionStatusEvent' }
  & Pick<TP.OptimizationExecutionStatusEvent, 'id' | 'type'>
  & { solutionProgress: TP.OptimizationExecutionStatusEvent['status'] }
);

export const OptimizationExecutionStatusEventPayloadFragmentDoc = gql`
    fragment OptimizationExecutionStatusEventPayload on OptimizationExecutionStatusEvent {
  id
  type
  solutionProgress: status
}
    `;